
// import LangSelect from '@/components/Lang.vue';
import PageHeader from '@/components/PageHeader.vue'
import PageFooter from '@/components/PageFooter.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    PageHeader,
    PageFooter
  }
})
export default class extends Vue {
  active: number = 1

  handleNav({ target }: any) {
    const active = target.dataset.active;
    if (active) {
      this.active = Number(active);
    }
  }
}
